import axios from 'axios';
import store from '@/store';
import router from '@/router';
import config from '@/config';
import {getLocalBank} from "@/utils/storage";

const LOCAL_TOKEN_SYMBOL = `${config.storagePre}_LOGIN_TOKEN`;

function getResult(response) {
  if(response && response.data) {
    return response.data;
  }
  throw new Error('API response without result field');
}

function handleError(error) {
  const {status, data} = error;
  switch (status) {
    case 403: {
      router.replace('/login');break;
    }
    case 500: {
      //token失效  返回首页
      if(data.message === 'Token失效，请重新登录') {
        store.commit('auth/CLEAR_TOKEN');
        router.replace('/unauthorized');
      }
      break;
    }
  }
}

const api = axios.create({
  baseURL: config.useMock?'/mock':'/',
  headers: {
    'accept': 'application/json',
    'content-type': 'application/json;charset=UTF-8',
  },
  dataType:"json",
  // transformRequest: [data => data && JSON.stringify(data)],
  timeout: 20000,
});
api.interceptors.request.use(
  requestConfig => {
    const {method, data, url} = requestConfig;
    if(method === 'get' && !!data) {
      const paramsArr = [];
      Object.keys(data).forEach(key => {
        paramsArr.push(`${key}=${data[key]}`);
      });
      if(url.indexOf('?') === -1) {
        requestConfig.url = `${url}?${paramsArr.join('&')}`;
      } else {
        requestConfig.url = `${url}&${paramsArr.join('&')}`;
      }
    }
    requestConfig.headers = {
      ...requestConfig.headers,
      'Token':  getLocalBank(LOCAL_TOKEN_SYMBOL),
    };
    return requestConfig;
  },
  error => Promise.reject(error),
);
api.interceptors.response.use(
  response => {
    return getResult(response);
  },
  error => {
    handleError(error.response);
  }
);

const AsyncCtrl = Object.create(null);
AsyncCtrl.install = function (Vue) {
  Vue.$Api = Vue.prototype.$api = api;
};

export {
  api
}

export default AsyncCtrl
